import { useState } from "react";

export function useToggle(initial) {
  const [value, setValue] = useState(initial);
  function toggleValue(state) {
    if (state !== undefined && !isEvent(state)) {
      setValue(state);
    } else {
      setValue(!value);
    }
  }
  return [value, toggleValue];
}

/**
 * Not the best way, but should work in this case.
 *
 * Quote often this hook gets used like this: onClick={toggle}, which
 * passes in the event.
 */
function isEvent(value) {
  return value?.type !== undefined;
}
